export default "__VITE_ASSET__edb254c8__"